import { Table } from 'antd';
import { ColumnProps, TablePaginationConfig } from 'antd/lib/table';
import { SorterResult } from 'antd/lib/table/interface';
import { BodyPageContainer } from 'client/ui/layout/body/BodyPageContainer';
import { tableLoaderSpin } from 'client/ui/loader/tableLoaderSpin';
import { IRequestsQueryDto } from 'common/dto/RequestDto';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import { IRequest } from 'common/schema/request/Request';
import React from 'react';

export interface IRequestListTableProps {
  loading: boolean | undefined;
  data: PaginatedResult<IRequest> | undefined;
  onChange: (
    pagination: TablePaginationConfig,
    filters: Record<string, React.ReactText[] | null>,
    sorter: SorterResult<IRequest> | SorterResult<IRequest>[]
  ) => void;
  query: IRequestsQueryDto;
  showHeader: boolean;
  columns: ColumnProps<IRequest>[];
}

export function RequestListTable(props: IRequestListTableProps) {
  const { loading, data, onChange, query, showHeader, columns } = props;
  return (
    <BodyPageContainer noTopPadding>
      <Table
        loading={tableLoaderSpin(loading || !data)}
        tableLayout="fixed"
        showHeader={showHeader}
        size="small"
        rowKey="id"
        dataSource={data?.items ?? []}
        columns={columns}
        onChange={onChange}
        pagination={{
          size: 'small',
          position: ['bottomRight'],
          showSizeChanger: true,
          total: data?.meta.total,
          pageSize: query.pageSize,
          current: query.page,
          pageSizeOptions: ['5', '10', '20', '30', '40']
        }}
      />
    </BodyPageContainer>
  );
}
